module.exports = __webpack_public_path__ + "img/anchor-icon.7297ee6a.svg";